import { Option, QuestionBaseInfoList } from '@/types';

export const TOKEN_INVALID_ERRCODE = 10000;

export const teacherPasswordReg =
  /^(?=.*?[0-9])(?=.*?[a-zA-Z])[a-zA-Z0-9]{6,16}$/;

export const studentPasswordReg = /^[a-zA-Z0-9]{6,16}$/;

// 手机号正则表达式
export const phonePattern = /^1\d{10}$/;
// 图片验证码表达式
export const imageCodePattern = /^[0-9a-zA-Z]{5}$/;
// 加密手机号正则表达式
export const encryptionPhonePattern = /^1\d{2}[*\d]{4}\d{4}$/;

// 密码正则表达式
export const passwordPattern = /^[0-9a-zA-Z]{6,16}$/;

// 身份证正则表达式
// export const idCardPattern = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
export const idCardPattern = /^[0-9a-zA-Z]{18}$/;

// 护照正则表达式
// export const passportPattern = /^([EK]\d{8}|(SE|DE|PE|MA)\d{7})$/;
export const passportPattern = /^[0-9a-zA-Z]{9}$/;

// 港澳通行证正则表达式
// export const gangAoPassPattern = /^[HMhm]{1}(\d{10}|\d{8})$/;
export const gangAoPassPattern = /^[0-9a-zA-Z]{9,11}$/;

// 不能包含特殊字符
export const normalStringPattern = /^[0-9a-zA-Z]*$/;

export const disableDigitValidator = (rule: any, value: any) => {
  return new Promise((resolve, reject) => {
    if (/\d/.test(value)) {
      reject('不能包含数字');
    } else {
      resolve(true);
    }
  });
};

// 在这里配置个性化的前端错误信息
// 当然这里是依据errCode来展示错误信息的
// 如果对于同一个errCode在不同的地方需要展示不同的错误信息，那么最好是让后端返回不同的错误信息。如果后端不好解决。
// 那么就需要前端使用X_DISABLE_ERROR禁止默认错误提示，然后在业务代码中自定义错误信息
export const ERROR_CODE_MESSAGE: Record<number, string> = {
  10000: '您已登出系统，请重新登录',
  123123: '系统内部错误，请刷新重试',
};

// 这个是针对Select的下拉框数据格式
// 包括通过id转汉字也需要这些数据
// 需要注意这里的id一定是数字类型的，不能是字符串类型的
export const SEX = [
  { label: '男', value: 1 },
  { label: '女', value: 2 },
];
export const CARD_TYPE = [
  { label: '身份证', value: 1 },
  { label: '护照', value: 2 },
  { label: '港澳通行证', value: 3 },
  { label: '其他', value: 4 },
];
export const QUESTION_TYPE = [
  { label: 'OJ题', value: 1 },
  { label: '单选题', value: 2 },
  { label: '填空题', value: 3 },
  { label: '多选题', value: 4 },
  { label: '编程题', value: 5 },
  { label: '自由创作题', value: 6 },
  { label: '编程题', value: 7 }, // 7 自动判分题显示为：编程题
  { label: '自由创作题', value: 8 }, // Python自由创作
  { label: '判断题', value: 20 },
  { label: '附件题', value: 21 },
];
export const QUESTION_TYPE_PROGRAM = [1, 5, 6, 7, 8];
export function IS_QUESTION_TYPE_PROGRAM(id: number) {
  return QUESTION_TYPE_PROGRAM.includes(id);
}
export const QUESTION_TYPE_CHOICE = [2, 4, 20];
export function IS_QUESTION_TYPE_CHOICE(id: number) {
  return QUESTION_TYPE_CHOICE.includes(id);
}
export function IS_QUESTION_TYPE_MULTI_CHOICE(id: number) {
  return id === 4;
}
export function IS_QUESTION_TYPE_FILL_BLANK(id: number) {
  return id === 3;
}

// 附件题的类型
export const QUESTION_TYPE_FILE = [21];

// 是否附件题的
export function IS_QUESTION_TYPE_FILE(id: number) {
  return QUESTION_TYPE_FILE.includes(id);
}

export const GRADE = [
  // { label: '学前', value: 1 },
  { label: '一年级', value: 2 },
  { label: '二年级', value: 3 },
  { label: '三年级', value: 4 },
  { label: '四年级', value: 5 },
  { label: '五年级', value: 6 },
  { label: '六年级', value: 7 },
  { label: '初一', value: 8 },
  { label: '初二', value: 9 },
  { label: '初三', value: 10 },
  { label: '初四', value: 11 },
  { label: '高一', value: 12 },
  { label: '高二', value: 13 },
  { label: '高三', value: 14 },
];

export const USER_EXAM_PASSED = [
  { label: '未晋级', value: 1 },
  { label: '已晋级', value: 2 },
  { label: '晋级已撤销', value: 3 },
];

export const USER_EXAM_AWARDED = [
  { label: '未获奖', value: 1 },
  { label: '已获奖', value: 2 },
  { label: '获奖已撤销', value: 3 },
];
// certificateGetMethod
export const CERTIFICATE_GET_METHODS = [
  { label: '电子版', value: 1 },
  { label: '纸质', value: 2 },
];

export function value2label(
  value: string | number,
  list: Option[],
  defaultValue: string | number = ''
) {
  for (const item of list) {
    if (item.value === value) {
      return item.label;
    }
  }
  return defaultValue;
}

export const getBaseInfoText = (info: QuestionBaseInfoList) => {
  const newInfo: QuestionBaseInfoList = [];
  const repeatMap: any = {};
  info.forEach(el => {
    if ([5, 7].includes(+el.questionTypeId)) {
      if (repeatMap['5,7']) {
        repeatMap['5,7'].count += el.count;
        repeatMap['5,7'].questionTypeIds.push(el.questionTypeId);
      } else {
        repeatMap['5,7'] = {
          count: el.count,
          questionTypeId: el.questionTypeId,
          questionTypeIds: [el.questionTypeId],
        };
        newInfo.push(repeatMap['5,7']);
      }
    } else {
      newInfo.push(el);
    }
  });
  return newInfo
    .map(
      info =>
        `${info.count}道${value2label(info.questionTypeId, QUESTION_TYPE)}`
    )
    .join('、');
};

export const CaptchaAppId = '193475643';

export const StoreLoginUrlName = 'PC_CONTEST_LOGIN_URL';
// key: b2c 的年级id  val: 赛事年级对应的gradeId数组 可能值
export const b2cAndContestGradeMapping: Record<string, number[]> = {
  // 一年级 --> 一年级
  1: [2],
  // 二年级 --> 二年级
  2: [3],
  // 三年级 --> 三年级
  3: [4],
  // 四年级 --> 四年级
  4: [5],
  // 五年级 --> 五年级
  5: [6],
  // 六年级 --> 六年级 初一
  6: [7, 8],
  // 七年级 --> 七年级 初二 初一
  7: [15, 9, 8],
  // 八年级 --> 八年级 初三 初二
  8: [16, 10, 9],
  // 九年级 --> 九年级 初四 初三
  9: [17, 11, 10],
  // 幼儿小班
  10: [1],
  // 幼儿中班
  11: [1],
  // 幼儿大班
  12: [1],
};

export const ContestPlatformVals = ['noc', 'icc', 'aild'];

export const OtherLoginSessionName = 'OTHER_LOGIN_URL_SESSION';

// 获取三方登录的url
export const getOtherLoginUrl = () => {
  return window.sessionStorage.getItem(OtherLoginSessionName);
};

// 清除三方登录的url
export const clearOtherLoginUrl = () => {
  window.sessionStorage.removeItem(OtherLoginSessionName);
};

// 设置第三方登录的url
export const setOtherLoginUrl = (url: string) => {
  window.sessionStorage.setItem(OtherLoginSessionName, url);
};

export const StateMap: Record<string, Record<string, string | number>> = {
  inProgressState: {
    text: '进行中',
    status: 1,
    attr: 'inProgressState',
  },
  waitState: {
    text: '待开始',
    status: 0,
    attr: 'waitState',
  },
  endState: {
    text: '已结束',
    status: 2,
    attr: 'endState',
  },
};
